export const Marquee = () => {
  const phrase = "EBC BRAKES";
  const items = Array.from({ length: 8 });
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/10 bg-black py-6 sm:py-8 overflow-hidden"
    >
      <div className="marquee-track">
        {[0, 1].map((group) => (
          <div key={group} className="flex items-center" aria-hidden={group === 1}>
            {items.map((_, i) => (
              <span key={i} className="flex items-center">
                <span
                  className={`font-display uppercase text-6xl sm:text-7xl lg:text-8xl px-6 ${
                    i % 2 === 0 ? "text-stroke" : "text-stroke-red"
                  }`}
                >
                  {phrase}
                </span>
                <span className="h-3 w-3 bg-ebc-red rotate-45 mx-2" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
